import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { useEffect } from 'react';
import { useCreateNewMessage } from '../../hooks/use-create-new-message';

export function ScreenError() {
	const { goToReceptionHome } = useCreateNewMessage();
	const { trackEvent, service } = useAnalyticContext();

	function handleRestart() {
		trackEvent('Clicked', 'Restart button');
		goToReceptionHome();
	}

	useEffect(() => {
		service.trackPageView({ customTitle: 'Create new message: Error' });
	}, [service]);

	return (
		<>
			<TopBar.Content onAbort={null} />

			<IllustrativeView
				title={withTranslation('View.CreateNewMessage.ErrorInterrupted.Title')}
				description={withTranslation('View.CreateNewMessage.ErrorInterrupted.Body')}
				illustration='error'
				callToAction={withTranslation('View.CreateNewMessage.ErrorInterrupted.Button')}
				callToActionCallback={handleRestart}
			/>
		</>
	);
}
